import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import type React from 'react'

import { Box } from '@fortum/elemental-ui'

import { CrosshairId } from '@/shared/components/SpotPrices/commons'

/* eslint-disable unicorn/prefer-top-level-await */
if (typeof window !== 'undefined' && typeof Highcharts === `object`) {
  import('highcharts/modules/accessibility')
    .then((module) => {
      if (typeof module.default === 'function') {
        module.default(Highcharts)
      }
    })
    .catch((error) => {
      console.error('Failed to load Highcharts accessibility module:', error)
    })
}

export type ChartProps = {
  config: Highcharts.Options
}

const CrosshairContainer = () => (
  <Box id={CrosshairId} display={{ m: 'none' }} style={{ pointerEvents: 'none' }} />
)

export const Chart: React.FC<ChartProps> = ({ config }) => (
  <Box position="relative">
    <CrosshairContainer />
    <HighchartsReact highcharts={Highcharts} options={config} />
  </Box>
)

export default Chart
